import { render } from "./PartnersListSlider.vue?vue&type=template&id=1ecf426a"
import script from "./PartnersListSlider.vue?vue&type=script&lang=js"
export * from "./PartnersListSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__